/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2021-01-29 11:07:27
 */

import React, { Component } from "react";
import { DataService } from "../services/data.service";
import loader from "../assets/images/loader.gif";
import { Empty } from "antd";
import $ from "jquery";
import * as handler from "../components/utils/handler";

class ServiceDetails extends Component {
  defaultCategory = window["app-config"].defaultCategory;
  defaultServices = window["app-config"].defaultServices;
  defaultLanguage = window["app-config"].defaultLang;
  isMandatoryImei = window["app-config"].isMandatoryImei;
  collections = window["app-config"].collections;
  URL = window["app-config"].URL;

  categoryId = null;
  deviceHealth = null;
  phoneServiceName = null;
  imei = null;

  imeiRef = React.createRef();
  isValidIemiSerielNumber = false;

  isRepairServiceSelected = false;

  dataService = new DataService();

  state = {
    categories: [],
    dataLoaded: false,
    singleBranchDetails: [],
    phoneServices: [],
    selectedCategory: null,
    selectedService: null,
    dataLoaded: false,
    serverResponded: true,
    imei: null,
    isValidImei: undefined,
    lang: {},
  };

  async componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
    this.getData();
    this.props.setHeading(null);
    this.props.hideBtnNext();
  }

  getData = async () => {
    try {
      var branchId = await (await this.dataService.getSingleBranchDetails())
        .data.branchList[0].BranchID;

      let phoneServiceResp = await this.dataService.getDeviceDetails();
      let categoryListResp = await this.dataService.getCategoriesByBranchId(
        branchId
      );

      let filteredCategories = handler.compareArrayOfObject(
        categoryListResp.data.categoryList,
        this.collections.categories
      );

      if (
        (phoneServiceResp.data.error !== undefined &&
          phoneServiceResp.data.error === true) ||
        (categoryListResp.data.error !== undefined &&
          categoryListResp.data.error === true)
      ) {
        this.setState({
          categories: [],
          dataLoaded: true,
          phoneServices: [],
          serverResponded: false,
        });
      } else {
        var phoneServices = phoneServiceResp.data.productsInfo.phoneService;
        let categoryList = categoryListResp.data.categoryList;

        this.setState({
          categories:
            filteredCategories.length > 0 ? filteredCategories : categoryList,
          dataLoaded: true,
          // singleBranchDetails: branchID,
          phoneServices: phoneServices,
        });
      }
    } catch (error) {
      console.log("ERROR", error.message);
      this.setState({
        categories: [],
        phoneServices: [],
        dataLoaded: true,
        singleBranchDetails: [],
        serverResponded: error.message.includes("timeout") ? false : true,
      });
    }
  };

  onCategoryChange = (e) => {
    this.categoryId = e.target.value;

    this.setState({ selectedCategory: e.target.value });

    if (e.target.value !== this.defaultCategory) {
      this.phoneServiceName = null;
      this.imei = null;
      this.setState({ selectedService: null, imei: null });
    }

    this.sendDataToParent();
  };

  onDeviceHealthChange = (e) => {
    if (this.state.isValidImei === false) {
      console.log("IN IF DH");
      this.props.hideBtnNext();
    } else if (
      this.defaultServices.includes(this.state.selectedService) &&
      this.state.imei === null &&
      this.isMandatoryImei === true &&
      this.state.isValidImei === undefined
    ) {
      console.log("IN ELSEIF DH");
      this.props.hideBtnNext();
    } else {
      console.log("IN ELSE DH");
      this.deviceHealth = e.target.value;
      this.sendDataToParent();
    }
  };

  onPhoneServiceChange = (e) => {
    this.phoneServiceName = e.target.value;
    this.setState({ selectedService: e.target.value });

    // if (e.target.value !== this.defaultService) {
    //   this.imei = null;
    // }

    this.sendDataToParent();

    if (
      this.defaultServices.includes(e.target.value) &&
      this.state.imei === null &&
      this.isMandatoryImei === true &&
      (this.state.isValidImei === false || this.state.isValidImei === undefined)
    ) {
      console.log("IN IF");
      this.props.hideBtnNext();
    } else if (
      !this.defaultServices.includes(e.target.value) &&
      this.state.isValidImei === false &&
      this.state.imei !== ""
    ) {
      console.log("IN ELSE IF");
      this.props.hideBtnNext();
    } else if (this.state.imei !== null && this.state.isValidImei === false) {
      this.props.hideBtnNext();
    } else {
      console.log("IN ELSE", this.state.isValidImei);
      console.log("IN ELSE IMEIE: ", this.state.imei);
      this.props.showBtnNext();
    }
  };

  onImeiChange = (e) => {
    if (e.target.value.length === 0) {
      $("#imei-field").css("border-color", "#dadada");
      this.setState({ isValidImei: undefined, imei: null });
      // this.isValidIemiSerielNumber = true;
      // this.imei = e.target.value;
      if (
        this.defaultServices.includes(this.state.selectedService) &&
        e.target.value === "" &&
        this.isMandatoryImei === true
      ) {
        this.props.hideBtnNext();
      } else {
        this.props.showBtnNext();
      }
    } else if (
      (e.target.value.length !== 0 && e.target.value.length < 11) ||
      /\s/.test(e.target.value) ||
      !/^[a-zA-ZÀ-ÿ0-9]+$/.test(e.target.value) ||
      (e.target.value.length > 11 && e.target.value.length < 15)
    ) {
      $("#imei-field").css("border-color", "red");
      // this.isValidIemiSerielNumber = false;
      this.setState({ isValidImei: false, imei: e.target.value });
      this.props.hideBtnNext();
    } else {
      $("#imei-field").css("border-color", "#dadada");
      // this.isValidIemiSerielNumber = true;
      // this.imei = e.target.value;
      this.setState({ imei: e.target.value, isValidImei: true });
      this.props.showBtnNext();
      this.sendDataToParent();
    }

    // if (this.state.isValidImei === false) {
    //   console.log("IMEI IF");
    //   this.props.hideBtnNext();
    // } else {
    //   console.log("IMEI ELSE");
    //   this.props.showBtnNext();
    // }
  };

  sendDataToParent = () => {
    this.props.serviceDetails({
      categoryId: this.categoryId,
      deviceHealth: this.deviceHealth,
      phoneServiceName:
        this.categoryId === this.defaultCategory &&
        this.phoneServiceName === null
          ? undefined
          : this.phoneServiceName,
      imei: this.state.imei === null ? null : this.state.imei,
    });
  };

  render() {
    if (this.state.dataLoaded === false) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellUsSomethingElse}</h2>

            <div className="sl__modal--row">
              <img src={loader}></img>
            </div>
          </div>
        </div>
      );
    } else if (!this.state.serverResponded) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <Empty description={this.state.lang.ServerNotResponding} />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellUsSomethingElse}</h2>
            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhenDidYouBuyIt}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="devicehealth-selector"
                  className="sl__modal_form--select"
                  defaultValue={-1}
                  onChange={this.onDeviceHealthChange}
                >
                  <option value={-1} disabled>
                    {this.state.lang.ChooseYourPurchaseDate}
                  </option>
                  <option value={this.state.lang.LessThanTwoYears}>
                    {this.state.lang.LessThanTwoYears}
                  </option>
                  <option value={this.state.lang.OverYearsAgo}>
                    {this.state.lang.OverYearsAgo}
                  </option>
                </select>
              </div>
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhatIsCategory}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="category-selector-sam"
                  className="sl__modal_form--select"
                  defaultValue={-1}
                  onChange={this.onCategoryChange}
                >
                  <option disabled value={-1}>
                    {this.state.lang.ChooseYourCategory}
                  </option>

                  {this.state.categories.length > 0
                    ? this.state.categories.map((data, i) => {
                        return (
                          <option value={data.CategoryID} key={i}>
                            {data.CategoryTitle}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </div>

            {this.state.selectedCategory === this.defaultCategory ? (
              <div className="sl__modal_form-row">
                <div className="sl__modal_form-col">
                  <label className="sl__modal_form--label">
                    {this.state.lang.WhatServiceWouldYouLikeToSelect}
                    <span className="estaric">*</span>
                  </label>
                  <select
                    id="service-selector"
                    className="sl__modal_form--select"
                    defaultValue={-1}
                    onChange={this.onPhoneServiceChange}
                  >
                    <option disabled value={-1}>
                      {this.state.lang.ChooseYourService}
                    </option>

                    {this.state.phoneServices.length > 0
                      ? this.state.phoneServices.map((data, i) => {
                          return (
                            <option value={data.ServiceName} key={i}>
                              {data.ServiceName}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
              </div>
            ) : null}

            {this.state.selectedService !== null ? (
              <div className="sl__modal_form-row">
                <div className="sl__modal_form-col wide">
                  <div className="imei-helper">
                    <span className="glyphicon glyphicon-info-sign info-ic"></span>
                    &nbsp;
                    <a
                      className="imei-link"
                      href={`${this.URL.imeiUrl}`}
                      target="_blank"
                    >
                      {this.state.lang.retrieveIMEI}
                    </a>
                  </div>
                  <label className="sl__modal_form--label">
                    {this.state.lang.DeviceIMEINumber}
                  </label>
                  <input
                    data-required="true"
                    type="text"
                    maxLength={15}
                    ref={this.imeiRef}
                    name="imei"
                    placeholder={this.state.lang.IMEIOrSerialNumber}
                    id="imei-field"
                    className="sl__modal_form--input validate-text"
                    onChange={this.onImeiChange}
                  />
                </div>
              </div>
            ) : null}

            {/* <div className="sl__modal_form-info">
              <p>{this.state.lang.DeviceParagraph}</p>
            </div> */}
          </div>
        </div>
      );
    }
  }
}

export default ServiceDetails;
